export const symbolify = (value: string, symbol: string) => {
  if (symbol === '$') {
    return `${symbol}${value}`;
  } else if (symbol === '%') {
    return `${value}${symbol}`;
  } else {
    return value;
  }
};
